import type { Template } from "@/types";

export const SQ_05_H0_V5: Template[] = [
    {
        id: "sq-05-h0v5-01",
        name: "SQ 01 - H0V5",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h0_v5_01.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 97, y: 176, width: 242, height: 365, rotation: 0, imageRotation: 0 },
            { id: "2", x: 347, y: 176, width: 241, height: 365, rotation: 0, imageRotation: 0 },
            { id: "3", x: 596, y: 176, width: 241, height: 365, rotation: 0, imageRotation: 0 },
            { id: "4", x: 845, y: 176, width: 241, height: 365, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1094, y: 176, width: 241, height: 365, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h0v5-02",
        name: "SQ 02 - H0V5",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h0_v5_02.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 147, width: 281, height: 423, rotation: 0, imageRotation: 0 },
            { id: "2", x: 289, y: 147, width: 281, height: 423, rotation: 0, imageRotation: 0 },
            { id: "3", x: 578, y: 147, width: 280, height: 423, rotation: 0, imageRotation: 0 },
            { id: "4", x: 866, y: 147, width: 280, height: 423, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1154, y: 147, width: 280, height: 423, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h0v5-03",
        name: "SQ 03 - H0V5",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h0_v5_03.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 151, y: 204, width: 204, height: 309, rotation: 0, imageRotation: 0 },
            { id: "2", x: 363, y: 204, width: 204, height: 309, rotation: 0, imageRotation: 0 },
            { id: "3", x: 758, y: 204, width: 204, height: 309, rotation: 0, imageRotation: 0 },
            { id: "4", x: 970, y: 204, width: 203, height: 309, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1181, y: 204, width: 203, height: 309, rotation: 0, imageRotation: 0 }          
        ],
    },

    {
        id: "sq-05-h0v5-04",
        name: "SQ 04 - H0V5",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h0_v5_04.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 51, y: 79, width: 375, height: 559, rotation: 0, imageRotation: 0 },
            { id: "2", x: 433, y: 79, width: 185, height: 276, rotation: 0, imageRotation: 0 },
            { id: "3", x: 433, y: 363, width: 185, height: 276, rotation: 0, imageRotation: 0 },
            { id: "4", x: 626, y: 79, width: 375, height: 559, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1009, y: 79, width: 375, height: 559, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h0v5-05",
        name: "SQ 05 - H0V5",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h0_v5_05.png",
        size: [1434, 717],
        style: {},
        slots: [       
            { id: "1", x: 50, y: 79, width: 376, height: 559, rotation: 0, imageRotation: 0 },
            { id: "2", x: 434, y: 79, width: 375, height: 559, rotation: 0, imageRotation: 0 },
            { id: "3", x: 817, y: 79, width: 375, height: 559, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1200, y: 79, width: 184, height: 276, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1200, y: 363, width: 184, height: 276, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h0v5-06",
        name: "SQ 06 - H0V5",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h0_v5_06.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 74, y: 78, width: 375, height: 561, rotation: 0, imageRotation: 0 },
            { id: "2", x: 457, y: 78, width: 185, height: 277, rotation: 0, imageRotation: 0 },
            { id: "3", x: 457, y: 363, width: 185, height: 276, rotation: 0, imageRotation: 0 },
            { id: "4", x: 790, y: 142, width: 282, height: 433, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1080, y: 142, width: 282, height: 433, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h0v5-07",
        name: "SQ 07 - H0V5",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h0_v5_07.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 99, y: 78, width: 387, height: 561, rotation: 0, imageRotation: 0 },
            { id: "2", x: 493, y: 268, width: 126, height: 182, rotation: 0, imageRotation: 0 },
            { id: "3", x: 493, y: 458, width: 126, height: 181, rotation: 0, imageRotation: 0 },
            { id: "4", x: 887, y: 78, width: 376, height: 561, rotation: 0, imageRotation: 0 },
            { id: "5", x: 493, y: 78, width: 126, height: 182, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h0v5-08",
        name: "SQ 08 - H0V5",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h0_v5_08.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 174, y: 78, width: 369, height: 561, rotation: 0, imageRotation: 0 },
            { id: "2", x: 884, y: 78, width: 188, height: 277, rotation: 0, imageRotation: 0 },
            { id: "3", x: 884, y: 363, width: 188, height: 276, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1080, y: 78, width: 188, height: 277, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1080, y: 363, width: 188, height: 276, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h0v5-09",
        name: "SQ 09 - H0V5",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h0_v5_09.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 117, y: 141, width: 286, height: 435, rotation: 0, imageRotation: 0 },
            { id: "2", x: 411, y: 76, width: 188, height: 278, rotation: 0, imageRotation: 0 },
            { id: "3", x: 411, y: 362, width: 188, height: 278, rotation: 0, imageRotation: 0 },
            { id: "4", x: 786, y: 141, width: 286, height: 435, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1080, y: 141, width: 286, height: 435, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h0v5-10",
        name: "SQ 10 - H0V5",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h0_v5_10.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 115, y: 0, width: 487, height: 717, rotation: 0, imageRotation: 0 },
            { id: "2", x: 815, y: 76, width: 388, height: 565, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1211, y: 76, width: 125, height: 183, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1211, y: 267, width: 125, height: 183, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1211, y: 458, width: 125, height: 183, rotation: 0, imageRotation: 0 }
        ],
    },
    

];

